import { Route, Routes } from "react-router-dom";
import { PagarIpvaLote } from "../Pages/Ipva/Lote";
import { PagamentoLote } from "../Pages/PagamentoLote";
import { Fornecedor } from "../Pages/Fornecedor";
import { FornecedorPagamento } from "../Pages/FornecedorPagamento";
import { PagarIpva } from "../Pages/PagarIpva";
import { PagamentoTaxa } from "../Pages/PagamentoTaxa";
import { CriarLotePagamentoTaxa } from "../Pages/PagamentoTaxa/CriarLote";
import { GerenciarPagamentos } from "../Pages/GerenciarPagamentos";

function FinanceiroRoutes() {
  return (
    <Routes>
      <Route path="/ipva/lote" element={<PagarIpvaLote />} />
      <Route path="/ipva/pagar" element={<PagarIpva />} />
      <Route path="/taxa/lote" element={<PagamentoLote />} />
      <Route path="/pagamento-taxa-sp/lote" element={<PagamentoTaxa />} />
      <Route path="/pagamento-taxa-sp/lote/criar" element={<CriarLotePagamentoTaxa />} />
      <Route path="/pagamento-taxa-sp/lote/criar/:id" element={<CriarLotePagamentoTaxa />} />
      <Route path="/fornecedor" element={<Fornecedor />} />
      <Route path="/fornecedor/pagamento" element={<FornecedorPagamento />} />
      <Route path="/pagamentos/gerenciar" element={<GerenciarPagamentos />} />
    </Routes>
  );
}
export { FinanceiroRoutes };
